import { combineReducers } from 'redux'
import doctorReducer from "./doctorReducer";
import specialityReducer from "./specialityReducer";
import blogReducer from "./blogReducer";
import offerReducer from "./offerReducer";
import { IntlReducer as Intl,  } from 'react-redux-multilingual'
import userReducer from "./userReducer";
import reservationReducer from "./reservationReducer";
import planReducer from "./planReducer";
import homeSliderReducer from "./homeSliderReducer";
import locationReducer from "./locationReucer";
import hospitalReducer from "./hospitalReducer";
import globalReducer from "./globalReducer";


const rootReducer = combineReducers({
    doctor: doctorReducer,
    hospital: hospitalReducer,
    specialty: specialityReducer,
    offer: offerReducer,
    blog: blogReducer,
    user: userReducer,
    reservation: reservationReducer,
    plan: planReducer,
    home: homeSliderReducer,
    location: locationReducer,
    global: globalReducer,
    Intl
});

export default rootReducer


